<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'AccountExports'}" class="subtitle-1 routerLink font-weight-medium">Exportar</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>Pagos
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 pb-0 background">
          <v-row class="px-4">
            <v-col cols="12" sm="10" md="9">
              <span class="body-2 text--secondary font-weight-medium">Filtrar registros</span>
              <v-query-builder :flat="true" :query-map="rules" filter-text="Previsualizar" model="subscription" />
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">Previsualización</span>
            </v-col>
          </v-row>
          <v-divider />
          <payment-list :show-pagination="false" />
          <v-divider />
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">{{count}} registros</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="createExport" :loading="$store.state.accounts.createLoader" color="primary">Exportar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import { paymentFilters } from '../../../collections/queryBuilderFilters'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import PaymentList from '@/components/payments/PaymentList'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VQueryBuilder,
    PaymentList
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    rules: paymentFilters
  }),
  computed: mapState({
    count: state => state.payments.paymentsCount
  }),
  methods: {
    getList () {
      this.$store.dispatch('payments/LIST', {
        resource: 'payments',
        query: Object.assign({}, this.$route.query, { page_size: 10 })
      })
    },
    createExport () {
      this.$store.dispatch('accounts/LIST', {
        resource: 'exports/payments',
        query: this.$route.query,
        loader: true,
        responseType: 'arraybuffer'
      })
      .then(async (response) => {
        let blob = await new Blob([response.data], {type: "application/zip"})
        saveAs(blob, 'payments.zip')
        this.$dialog.message.info('La exportación se realizó con éxito')
      })
      .catch(() => {
        this.$dialog.message.error('Ha ocurrido un error en la exportación')
      })
    }
  }
}
</script>